import type { IconSvgObject } from './types';

const HospitalLocationIcon: IconSvgObject = [
  ["path", { d: "M12 2C7.58172 2 4 5.61786 4 10.0807C4 14.8632 8.354 17.3042 11.0855 20.7083C11.5455 21.2816 12.476 21.2962 12.9462 20.7312C15.7269 17.3897 20 14.7722 20 10.0807C20 5.61786 16.4183 2 12 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 7.5V10M10 12.5V10M14 7.5V10M14 12.5V10M14 10H10", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default HospitalLocationIcon;
